"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const auth_1 = require("../auth");
const Workspace_1 = require("../auth/Workspace");
exports.ACCESS_KEY_CREDENTIALS = [
    'accessToken',
    'secretToken',
    'publicToken',
    'clientId',
    'clientSecret',
];
let AccessKey = class AccessKey extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User, { nullable: true }),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], AccessKey.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workspace_1.Workspace),
    typeorm_1.ManyToOne(() => Workspace_1.Workspace),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], AccessKey.prototype, "workspace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: 'Access Key' }),
    tslib_1.__metadata("design:type", String)
], AccessKey.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String]),
    typeorm_1.Column({
        default: ['accessToken'],
        type: 'jsonb',
    }),
    class_validator_1.IsArray(),
    class_validator_1.ArrayUnique(),
    class_validator_1.IsJSON(),
    class_validator_1.IsIn(exports.ACCESS_KEY_CREDENTIALS, {
        each: true,
    }),
    tslib_1.__metadata("design:type", Array)
], AccessKey.prototype, "credentialsNeededForValidKey", void 0);
tslib_1.__decorate([
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], AccessKey.prototype, "accessToken", void 0);
tslib_1.__decorate([
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], AccessKey.prototype, "refreshToken", void 0);
tslib_1.__decorate([
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], AccessKey.prototype, "secretToken", void 0);
tslib_1.__decorate([
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], AccessKey.prototype, "publicToken", void 0);
tslib_1.__decorate([
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], AccessKey.prototype, "clientId", void 0);
tslib_1.__decorate([
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], AccessKey.prototype, "clientSecret", void 0);
AccessKey = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], AccessKey);
exports.AccessKey = AccessKey;
class AccessKeyEntity extends AccessKey {
    toString() {
        return this.name;
    }
}
exports.AccessKeyEntity = AccessKeyEntity;
//# sourceMappingURL=AccessKey.js.map